<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="EP"><span epub:type="pagebreak" id="pg_vii" title="vii">There is another world, but it is in this one.</span></p>
<p class="EPC"><span class="ePub-SC-B">—PAUL ÉLUARD</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?42be81df